import React, { useState, useEffect } from 'react';
import { SbModal, SbForm, SbButton, SbInput } from '../../../../uiCore';

const IndustryModal = ({ visible, onClose, initialData, onSave, cardKey }) => {
  const [form] = SbForm.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && initialData) {
      const industryValue = Array.isArray(initialData.org_industry) 
        ? initialData.org_industry.join(', ') 
        : '';
      
      form.setFieldsValue({
        industry: industryValue
      });
    }
  }, [visible, initialData, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const changedFields = {};
      
      const newIndustryArray = values.industry
        .split(',')
        .map(item => item.trim())
        .filter(item => item.length > 0);
      
      const oldIndustry = Array.isArray(initialData?.org_industry) ? initialData.org_industry : [];
      
      const industryChanged = JSON.stringify(newIndustryArray.sort()) !== JSON.stringify(oldIndustry.sort());
      if (industryChanged) {
        changedFields.org_industry = newIndustryArray;
      }

      if (Object.keys(changedFields).length === 0) {
        onClose();
        return;
      }

      const result = await onSave(cardKey, changedFields);
      if (result.success) {
        onClose();
      }
    } catch (error) {
      console.error('Validation failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <SbModal
      title="Industry"
      open={visible}
      onCancel={handleCancel}
      width={480}
      footer={[
        <SbButton key="cancel" buttonType="secondary" onClick={handleCancel}>
          Cancel
        </SbButton>,
        <SbButton key="save" buttonType="primary" loading={loading} onClick={handleSave}>
          Save
        </SbButton>
      ]}
    >
      <SbForm form={form} layout="vertical">
        <SbForm.Item
          label="Industry"
          name="industry"
          rules={[
            { required: true, message: 'Please enter at least one industry' },
            { max: 200, message: 'Maximum 200 characters' }
          ]}
          help="Enter industry or industries separated by commas (e.g. Technology, Software)"
        >
          <SbInput 
            placeholder="e.g., Technology, Software, SaaS"
            maxLength={200}
          />
        </SbForm.Item>
      </SbForm>
    </SbModal>
  );
};

export default IndustryModal;
